import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Button,
  Dropdown,
  Grid,
  Label,
  Loader,
  Menu,
  Header,
  Segment,
  Table,
} from 'semantic-ui-react';
import qs from 'qs';
import { withTranslation } from 'react-i18next';

import { fetchAPI } from '../actions/fetchM';
import { flashErrorMessage } from '../actions/flash';

import * as endpoints from '../constants/apiEndpoints';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';

import LawyerItem from './LawyerItem';

class ProjectPanelLawyers extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    loanTrackerProjectID: PropTypes.number.isRequired,
    project: PropTypes.shape({
      autoAssignLawyerStatus: PropTypes.string,
      lawyerSpaUpdateEmails: PropTypes.array,
      lawyerLaUpdateEmails: PropTypes.array,
    }),
    loading: PropTypes.bool,
    extraNode: PropTypes.node,
    buttonNode: PropTypes.node,
    emptyNode: PropTypes.func,
    onChange: PropTypes.func,
    onStatusChange: PropTypes.func,
    onSettingsChange: PropTypes.func,
    onEmailsChange: PropTypes.func,
    itemNode: PropTypes.func,
    rowNode: PropTypes.func,
    allowLawyerAssignWithoutIC: PropTypes.bool,
    updateProjectLoading: PropTypes.bool,
    panelLawyerSettings: PropTypes.bool,
    t: PropTypes.func,
  }
  static defaultProps = {
    panelLawyerSettings: false,
  }
  constructor(props) {
    super(props);
    const tabs = [
      { text: props.t('Panel Lawyer'), name: 'panel', value: 'panel' },
    ];
    this.state = {
      loading: false,
      tabs,
      currentTab: tabs[0].name,
      lawyers: [],
      invited: [],
      nextToken: {},
    };
  }
  componentDidMount() {
    const { loanTrackerProjectID } = this.props;
    if (loanTrackerProjectID > 0) {
      this.refresh();
    }
  }
  componentWillReceiveProps(nextProps) {
    const { loanTrackerProjectID } = nextProps;
    if (loanTrackerProjectID !== this.props.loanTrackerProjectID) {
      this.refresh(null, loanTrackerProjectID);
    }
  }
  setLoading = (loading = false) => new Promise(res => this.setState({ loading }, () => res(loading)))
  setComponentState = (state = {}) => new Promise(res => this.setState(state, () => res(state)))
  setLawyers = (data = [], token, expand = false) => new Promise((res) => {
    const lawyers = expand ? [].concat(this.state.lawyers, data) : data || [];
    const { nextToken } = this.state;
    nextToken.panel = token;
    this.setState({
      lawyers,
      nextToken,
    }, () => {
      this.handleOnChange(lawyers);
      res(data, token);
    });
  })
  setInvited = (data = [], token, expand = false) => new Promise((res) => {
    const invited = expand ? [].concat(this.state.invited, data) : data || [];
    const { nextToken } = this.state;
    nextToken.invited = token;
    this.setState({
      invited,
      nextToken,
    }, () => res(data, token));
  })
  refresh = (token, projectID = this.props.loanTrackerProjectID) => {
    const { currentTab } = this.state;
    if (currentTab === 'invited') {
      this.fetchInvitedLawyers(token, projectID);
    } else {
      this.fetchPanelLawyers(token, projectID);
    }
  }
  fetchPanelLawyers = async (nextToken, projectID = this.props.loanTrackerProjectID) => {
    await this.setComponentState({ loading: true });
    const { store } = this.context;
    const { t } = this.props;
    if (!projectID) {
      await store.dispatch(flashErrorMessage({ message: `${t('This project is not linked in loan tracker', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    const query = {
      limit: 10,
    };
    if (nextToken) {
      query.next_token = nextToken;
    }
    let res;
    try {
      res = await store.dispatch(fetchAPI('lawyerAPI', `${endpoints.PANEL_LAWYERS(projectID)}/?${qs.stringify(query)}`, null, 'get', {
        'X-Api-Token': process.env.LAWYER_API_TOKEN,
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }

    if (res) {
      await this.setLawyers(res.items, res.next_token, !!nextToken);
    }

    await this.setLoading(false);
  }
  fetchInvitedLawyers = async (nextToken) => {
    await this.setComponentState({ loading: true });
    const { store } = this.context;
    const { t } = this.props;
    const query = {
      limit: 10,
    };
    if (nextToken) {
      query.next_token = nextToken;
    }
    let res;
    try {
      res = await store.dispatch(fetchAPI('lawyerAPI', `${endpoints.LAWYER_INVITES}/?${qs.stringify(query)}`, null, 'get', {
        'X-Api-Token': process.env.LAWYER_API_TOKEN,
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }

    if (res) {
      await this.setInvited(res.items, res.next_token, !!nextToken);
    }

    await this.setLoading(false);
  }
  getAutoAssignOptions = () => [
    { text: 'Booked', value: 'booked' },
    { text: 'Reserved', value: 'reserved' },
    { text: 'Sold', value: 'sold_spa_signed' },
  ];
  handleLoadMore = () => {
    const { loanTrackerProjectID } = this.props;
    const { nextToken, currentTab } = this.state;
    if (loanTrackerProjectID) {
      const token = nextToken[currentTab];
      this.refresh(token);
    }
  }
  handleChangeTab = (e, { name, value }) => {
    const currentTab = name || value;
    this.setState({ currentTab }, () => {
      this.refresh();
    });
  }
  handleOnChange = (lawyers) => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(lawyers);
    }
  }
  handleOnChangeAutoAssignStatus = (e, value) => {
    const { onStatusChange } = this.props;
    if (onStatusChange) {
      onStatusChange(value.value);
    }
  }
  handleOnChangeAssignWithoutIC = (e, value) => {
    const { onSettingsChange } = this.props;
    if (onSettingsChange) {
      onSettingsChange({
        name: value.name,
        value: value.checked,
      });
    }
  }
  handleOnChangeEmails = (e, { name, value }) => {
    const { onEmailsChange } = this.props;
    if (onEmailsChange) {
      onEmailsChange(name, value);
    }
  }
  renderItemNode = (lawyer, idx, currentTab) => {
    const { itemNode } = this.props;
    if (itemNode) {
      return itemNode(lawyer, idx, currentTab);
    }
    return (
      <LawyerItem
        item={lawyer}
        disabled={this.state.loading}
      />
    );
  }
  renderContent = () => {
    const { rowNode } = this.props;
    const { currentTab, lawyers, invited } = this.state;
    const list = currentTab === 'invited' ? invited : lawyers;
    if (list.length > 0) {
      return list.map((lawyer, idx) => {
        if (rowNode) {
          return rowNode(lawyer, idx, currentTab);
        }
        return (
          <Table.Row key={idx}>
            <Table.Cell>
              {this.renderItemNode(lawyer, idx, currentTab)}
            </Table.Cell>
          </Table.Row>
        );
      });
    }
    return (
      <Table.Row>
        <Table.Cell textAlign="center">
          {this.renderEmptyNode()}
        </Table.Cell>
      </Table.Row>
    );
  }
  renderEmptyNode = () => {
    const { emptyNode, t } = this.props;
    const { currentTab } = this.state;
    if (emptyNode) {
      return emptyNode(currentTab);
    }
    return <p>{t('No {{currentTab}} lawyer found', { currentTab, ns: TRANSLATION_FILES.screens })}.</p>;
  }
  renderLoadMore = () => {
    const { currentTab, lawyers, invited, nextToken } = this.state;
    const { t } = this.props;
    const list = currentTab === 'invited' ? invited : lawyers;
    if (list.length > 0 && nextToken[currentTab]) {
      return (
        <Segment basic textAlign="center">
          <Button
            onClick={this.handleLoadMore}
            content={t('Load more')}
          />
        </Segment>
      );
    }
    return null;
  }
  render() {
    const { allowLawyerAssignWithoutIC, buttonNode, extraNode, panelLawyerSettings, project, updateProjectLoading, t } = this.props;
    const { tabs } = this.state;
    const loading = this.state.loading || this.props.loading;
    return (
      <Grid className="ProjectPanelLawyers">
        {
          panelLawyerSettings && (
            <Form>
              <Grid.Row style={{ marginBottom: '20px' }}>
                <Grid.Column width={16} style={{ marginTop: '13px' }}>
                  <Header as="h4">SPA Lawyer Settings</Header>
                  <Label className="LawyerAutoAssignSettings">
                    {t('Auto-assign case to pre-assigned SPA Lawyers when status is')} &nbsp;
                    <Dropdown
                      onChange={this.handleOnChangeAutoAssignStatus}
                      options={this.getAutoAssignOptions().map(o => ({
                        ...o,
                        text: t(o.text, { ns: TRANSLATION_FILES.constants }),
                      }))}
                      selection
                      value={project && project.autoAssignLawyerStatus ? project.autoAssignLawyerStatus : ''}
                    />
                  </Label>
                </Grid.Column>
                <Grid.Column width={16}>
                  <Segment basic>
                    <Form.Checkbox
                      label="Allow lawyer assignments without purchaser IC"
                      checked={allowLawyerAssignWithoutIC}
                      name="allowLawyerAssignWithoutIC"
                      onChange={this.handleOnChangeAssignWithoutIC}
                    />
                  </Segment>
                </Grid.Column>
                <Grid.Column width={16} style={{ marginTop: '20px' }}>
                  <Header as="h4">Lawyer Email Notification</Header>
                  <Form.Field>
                    <label htmlFor="lawyerSpaUpdateEmails">SPA Status Update Notification</label>
                    <Dropdown
                      name="lawyerSpaUpdateEmails"
                      onChange={this.handleOnChangeEmails}
                      options={
                        project && project.lawyerSpaUpdateEmails ?
                          project.lawyerSpaUpdateEmails.map(eml => ({
                            text: eml,
                            value: eml,
                          })) :
                          []
                      }
                      value={project && project.lawyerSpaUpdateEmails ? project.lawyerSpaUpdateEmails : []}
                      placeholder={t('Add emails')}
                      noResultsMessage={t('Add emails')}
                      search
                      selection
                      fluid
                      multiple
                      allowAdditions
                    />
                  </Form.Field>
                  <Form.Field>
                    <label htmlFor="lawyerLaUpdateEmails">LA Status Update Notification</label>
                    <Dropdown
                      name="lawyerLaUpdateEmails"
                      onChange={this.handleOnChangeEmails}
                      options={
                        project && project.lawyerLaUpdateEmails ?
                          project.lawyerLaUpdateEmails.map(eml => ({
                            text: eml,
                            value: eml,
                          })) :
                          []
                      }
                      value={project && project.lawyerLaUpdateEmails ? project.lawyerLaUpdateEmails : []}
                      placeholder={t('Add emails')}
                      noResultsMessage={t('Add emails')}
                      search
                      selection
                      fluid
                      multiple
                      allowAdditions
                    />
                  </Form.Field>
                </Grid.Column>
              </Grid.Row>
            </Form>
          )
        }
        <Grid.Row>
          <Grid.Column width={16}>
            <Menu
              fluid
              attached="top"
              tabular
            >
              {
                tabs.map((tab, key) => (
                  <Menu.Item
                    key={key}
                    name={tab.name}
                    onClick={this.handleChangeTab}
                    active={this.state.currentTab === tab.value}
                  >{tab.text}</Menu.Item>
                ))
              }
              <Menu.Menu position="right">
                {buttonNode}
              </Menu.Menu>
            </Menu>
            <Table unstackable attached="bottom">
              <Table.Body>
                {
                  loading && !updateProjectLoading ? (
                    <Table.Row>
                      <Table.Cell textAlign="center">
                        <Loader active inline="centered" />
                      </Table.Cell>
                    </Table.Row>
                  ) : this.renderContent()
                }
              </Table.Body>
            </Table>
            {this.renderLoadMore()}
          </Grid.Column>
        </Grid.Row>
        {
          extraNode ? (
            <Grid.Row>
              <Grid.Column width={16}>
                {extraNode}
              </Grid.Column>
            </Grid.Row>
          ) : null
        }
      </Grid>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(ProjectPanelLawyers);



// WEBPACK FOOTER //
// ./src/components/ProjectPanelLawyers.jsx